import { ActionType } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { SET_ACTION_TAKEN_LABELS } from './constants';
import * as actionTakenLabelActions from './actions';
import { ActionTakenLabelsState } from './action-taken-labels';

export type ActionTakenLabelsAction = ActionType<typeof actionTakenLabelActions>;

export default combineReducers<ActionTakenLabelsState, ActionTakenLabelsAction>({
  bySubscriberId: (state = {}, action) => {
    switch (action.type) {
      case SET_ACTION_TAKEN_LABELS:
        return { ...state, [action.payload.subscriberId]: action.payload.config };
      default:
        return state;
    }
  },
});
